import React from 'react';

interface GlassButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  isDarkMode?: boolean;
  className?: string;
}

export const GlassButton: React.FC<GlassButtonProps> = ({
  onClick,
  children,
  isDarkMode = false,
  className = ''
}) => {
  return (
    <div className="perspective-1000">
      <button
        onClick={onClick}
        className={`
          relative px-6 h-12 rounded-full cursor-pointer overflow-hidden
          transform-gpu transition-all duration-300 ease-[cubic-bezier(0.68,-0.55,0.27,1.55)]
          ${isDarkMode
            ? 'bg-gradient-to-b from-white/15 to-white/5'
            : 'bg-gradient-to-b from-black/15 to-black/5'
          }
          shadow-[inset_0_1px_2px_rgba(255,255,255,0.1),inset_0_-1px_2px_rgba(0,0,0,0.1),0_4px_8px_rgba(0,0,0,0.1),0_0_20px_rgba(255,255,255,0.1)]
          hover:shadow-[inset_0_1px_2px_rgba(255,255,255,0.4),inset_0_-1px_2px_rgba(0,0,0,0.2),0_4px_8px_rgba(0,0,0,0.2),0_0_20px_rgba(255,255,255,0.1)]
          active:shadow-[inset_0_1px_2px_rgba(255,255,255,0.4),inset_0_-1px_2px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.2),0_0_10px_rgba(255,255,255,0.1)]
          [transform:rotateX(15deg)_translateZ(0)]
          ${className}
        `}
      >
        {/* Ground shadow */}
        <div className="absolute -bottom-[10px] left-[10%] w-[80%] h-[10px] bg-radial-shadow -z-10" />

        {/* Text */}
        <span className={`
          relative z-20 flex items-center justify-center  h-full text-lg font-sans
          ${isDarkMode ? 'text-white' : 'text-slate-900'}
        `}>
          {children}
        </span>
      </button>

      <style>{`
        @keyframes pulse-glow {
          0%, 100% {
            box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.4),
                        inset 0 -1px 2px rgba(0, 0, 0, 0.2),
                        0 4px 8px rgba(0, 0, 0, 0.2),
                        0 0 20px rgba(255, 255, 255, 0.1);
          }
          50% {
            box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.4),
                        inset 0 -1px 2px rgba(0, 0, 0, 0.2),
                        0 4px 8px rgba(0, 0, 0, 0.2),
                        0 0 30px rgba(255, 255, 255, 0.2);
          }
        }

        .animate-pulse-glow {
          animation: pulse-glow 2s infinite ease-in-out;
        }

        .perspective-1000 {
          perspective: 1000px;
        }

        .bg-radial-shadow {
          background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.3) 0%, transparent 70%);
        }

        .text-shadow-\\[0_1px_2px_rgba\\(0\\,0\\,0\\,0\\.5\\)\\] {
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </div>
  );
};
